function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import Decimal from "decimal.js";
var SafeDecimal = /*#__PURE__*/function (_Decimal) {
  _inherits(SafeDecimal, _Decimal);
  var _super = _createSuper(SafeDecimal);
  function SafeDecimal(props) {
    var _this;
    _classCallCheck(this, SafeDecimal);
    try {
      _this = _super.call(this, props);
    } catch (e) {
      _this = _super.call(this, 0);
    }
    return _this;
  }
  return _createClass(SafeDecimal);
}(Decimal);
/**
 * 格式化数字
 * @param num - 要格式化的数字
 * @param options - 格式化选项
 * @param options.decimal - 保留的小数位数，如果传入 undefined 则使用 num 默认的精度
 * @param options.rounded - 取整方式，如果传入 undefined 则不做任何取整处理
 * @param options.isSep - 是否添加千分位分隔符，默认为 true
 * @param options.isPad - 是否需要补零，默认为 true
 * @param options.positiveSymbol - 是否需要给正数补+符号
 * @returns 格式化后的字符串
 */
export var formatNum = function formatNum(num) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    decimal = _ref.decimal,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? "floor" : _ref$rounded,
    _ref$isSep = _ref.isSep,
    isSep = _ref$isSep === void 0 ? true : _ref$isSep,
    _ref$isPad = _ref.isPad,
    isPad = _ref$isPad === void 0 ? true : _ref$isPad,
    _ref$positiveSymbol = _ref.positiveSymbol,
    positiveSymbol = _ref$positiveSymbol === void 0 ? false : _ref$positiveSymbol;
  // 处理小数位数
  var roundedNumber = new SafeDecimal(num);
  if (decimal !== undefined && decimal !== null) {
    var factor = Math.pow(10, decimal);
    switch (rounded) {
      case "ceil":
        roundedNumber = roundedNumber.toDP(decimal, Decimal.ROUND_CEIL);
        break;
      case "floor":
        roundedNumber = roundedNumber.toDP(decimal, Decimal.ROUND_FLOOR);
        break;
      case "round":
        roundedNumber = roundedNumber.mul(factor).round().div(factor);
        break;
      case "up":
        roundedNumber = roundedNumber.toDP(decimal, Decimal.ROUND_UP);
        break;
      case "down":
        roundedNumber = roundedNumber.toDP(decimal, Decimal.ROUND_DOWN);
        break;
      default:
        break;
    }
  } else {
    var _roundedNumber$toStri = roundedNumber.toString().split("."),
      _roundedNumber$toStri2 = _slicedToArray(_roundedNumber$toStri, 2),
      decimalPart = _roundedNumber$toStri2[1];
    decimal = decimalPart === null || decimalPart === void 0 ? void 0 : decimalPart.length;
  }

  // 处理千分位分隔符
  var formattedNumber = isSep ? roundedNumber.toNumber().toLocaleString(undefined, {
    maximumFractionDigits: typeof decimal === "number" ? decimal > 20 ? 20 : decimal : undefined
  }) : roundedNumber.toString();

  // 处理补零
  if (isPad && decimal !== undefined && decimal > 0) {
    var _formattedNumber$spli = formattedNumber.split("."),
      _formattedNumber$spli2 = _slicedToArray(_formattedNumber$spli, 2),
      intPart = _formattedNumber$spli2[0],
      _formattedNumber$spli3 = _formattedNumber$spli2[1],
      _decimalPart = _formattedNumber$spli3 === void 0 ? "" : _formattedNumber$spli3;
    if (decimal <= _decimalPart.length) {
      formattedNumber = intPart + "." + _decimalPart;
    } else {
      var paddedDecimalPart = _decimalPart.padEnd(decimal, "0");
      formattedNumber = intPart + "." + paddedDecimalPart;
    }
  }

  // 处理正数补加号
  if (positiveSymbol && roundedNumber.greaterThan(0)) {
    formattedNumber = "+".concat(formattedNumber);
  }
  return formattedNumber;
};

/**
 * 格式化数字
 * @param num - 要格式化的数字
 * @returns 返回正确单位的数字并保留两位小数
 */
export var formatNumWithUnit = function formatNumWithUnit(num) {
  var unit = 1;
  var suffix = "";
  var safeNum = new SafeDecimal(num);
  if (safeNum.gte(1000000000)) {
    unit = 1000000000;
    suffix = "B";
  } else if (safeNum.gte(1000000)) {
    unit = 1000000;
    suffix = "M";
  } else {
    unit = 1000;
    suffix = "K";
  }
  // 将字符串类型的数值转换为数字类型
  var number = typeof num === "string" ? parseFloat(num) : num;
  number = number / unit;
  return "".concat(formatNum(number, {
    decimal: 2
  })).concat(suffix);
};